import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ObservablesService } from 'src/app/services/observables/observables.service';
import { MyDataService } from '../../data/data.service';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root',
})
export class RegisterService {
  constructor(
    private http: HttpClient,
    public router: Router,
    private observables: ObservablesService,
    private dataSvc: MyDataService,
    private translocoService: TranslocoService
    
  ) {}

  register(datos: any, direccion: any, proyecto: any): Observable<any> {
    return new Observable<any>((observer) => {
      const body = {
        datos: datos,
        direccion: direccion,
        proyecto: proyecto,
      };

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/area-clientes-register',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            console.log('Error registro: ', err);
            let msgError =
              'No se ha podido registrar la cuenta de usuario correctamente.';

            observer.error(msgError);
          }
        );
    });
  }

  activateClient(userID: number, codigo: string): Observable<any> {
    return new Observable<any>((observer) => {
      const body = {
        userID,
        codigo
      };

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/activate-client',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(true);
          },
          (err) => {
            console.log('Error activar usuario: ', err);
            let msgError = 'Código de activación incorrecto.';
            observer.error(msgError);
          }
        );
    });
  }


  sendMailConfirm(email: string, username: string, userID: number): Observable<any> {
    return new Observable<any>((observer) => {
      const proyectoPlatform = this.dataSvc.getFkEntityPlatform();
      const lang = this.translocoService.getActiveLang();
      const logo = this.dataSvc.getLogo();
      const logo2 = this.dataSvc.getLogo2();
      const logo3 = this.dataSvc.getLogo3();

      const body = {
        email,
        username,
        userID,
        proyectoPlatform,
        lang,
        logo,
        logo2,
        logo3
      };

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/send-mail-creacion-user',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(true);
          },
          (err) => {
            console.log('Error enviar código activación: ', err);
            let msgError = 'No se ha podido enviar el código de activación.';
            observer.error(msgError);
          }
        );
    });
  }




  comprobarEmail(email: string): Observable<any> {
    return new Observable<any>((observer) => {
      const body = {
        email: email,
      };

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/comprobar-existe-email',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(!response);
          },
          (err) => {
            console.log('Error comprobando el email: ', err);
            let msgError = 'Ha fallado la comprobación del email';

            observer.error(msgError);
          }
        );
    });
  }
}
